module.exports = __webpack_public_path__ + "img/f562237.jpg";